import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Baseproperties } from '../../utility/baseproperties';

@Injectable({
  providedIn: 'root'
})
export class ClientusagereportService {
  baseproperties: Baseproperties = new Baseproperties(); 
    downloadexcelformate_text="Please download this Excel Format. It will be saved in your Download directory by default. Please check for the latest file that is downloaded since Excel does a version control if the file with the same name exists. Open the Excel file and enter the requested information in the columns provided."
    refreshfilter=new BehaviorSubject<any>('');
    filtersObservable=new BehaviorSubject<any>(null); 
    selecteditems=new BehaviorSubject<any>([]);
    private baseURL = this.baseproperties.gatewayBaseURL;
    constructor(private httpClient: HttpClient) { }
  
    gettabledata(payload): Observable<any> {
      return this.httpClient.post(`${this.baseURL}/common/clientusagereport/gettabledata`,payload);
  }

    getcompanystats(payload): Observable<any> {
      return this.httpClient.post(`${this.baseURL}/common/clientusagereport/getcompanystats`,payload);
    } 
   
    filterrefresh(){
      this.refreshfilter.next('refresh');
    }
      
    getFilterChange(filterdata){
      this.filtersObservable.next(filterdata)
    }
  
    getorganisations(): Observable<any> {
      return this.httpClient.get(`${this.baseURL}/common/clientusagereport/getorganisations`);
    }
  
    orgStatsDataExcel(payload)
  {
     return this.httpClient.get(`${this.baseURL}/common/clientusagereport/orgStatsDataExcel`,{ responseType: 'blob' }); 
  }

  exceldatadownload()
  {
     return this.httpClient.get(`${this.baseURL}/common/clientusagereport/exceldatadownload`,{ responseType: 'blob' }); 
  }
exceldatadownloadall()
  {
     return this.httpClient.get(`${this.baseURL}/common/clientusagereport/exceldatadownloadall`,{ responseType: 'blob' });
  }
}
